export const donationAmounts = [
  { amount: 25, impact: 'Helps bring Honduran art, food, and tradition to a community celebration.' },
  { amount: 50, impact: 'Helps spotlight a Honduran-owned business to new audiences across L.A.' },
  { amount: 100, impact: 'Supports cultural and educational programming for the next generation.' },
  { amount: 250, impact: 'Helps power partnerships across our Los Angeles coalition.' },
];
